import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-header">
        <h1>Privacy Policy (Delivery Partners)</h1>
      </div>

      <div className="privacy-content">
        <p className="updated-date">Last Updated: November 2025</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to <strong>RismicMart Pvt. Ltd.</strong> This Privacy Policy
            explains how we collect, use, store, and protect the information of
            individuals who register or work as delivery partners (“you” or
            “delivery partner”) with our platform. By continuing to use our
            services, you agree to the practices described here.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We may collect the following categories of information from you:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> Name, contact number, email,
              address, and identification proofs (such as Aadhaar, PAN, or
              driver’s license).
            </li>
            <li>
              <strong>Professional Details:</strong> Vehicle information, license
              details, and experience.
            </li>
            <li>
              <strong>Financial Details:</strong> Bank account or UPI information
              for payments.
            </li>
            <li>
              <strong>Device Information:</strong> Device type, app version, and
              operating system used for accessing the delivery app.
            </li>
            <li>
              <strong>Location Data:</strong> Real-time GPS location during
              active deliveries to ensure route optimization and accurate
              delivery updates.
            </li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use the Information</h2>
          <p>Your data may be used for the following purposes:</p>
          <ul>
            <li>Assigning and managing delivery tasks.</li>
            <li>Processing your payments and incentives.</li>
            <li>Communicating important updates and notifications.</li>
            <li>Ensuring safety, security, and quality compliance.</li>
            <li>Improving delivery experience and app performance.</li>
          </ul>
        </section>

        <section>
          <h2>4. Location Tracking</h2>
          <p>
            When you are online and available for delivery, your GPS location is
            collected in real time to:
          </p>
          <ul>
            <li>Display your proximity to delivery points.</li>
            <li>Optimize routes and estimate delivery time.</li>
            <li>Provide customers and admin with accurate tracking.</li>
          </ul>
          <p>
            Your location is not tracked when you are logged out or offline from
            the RismicMart Delivery App.
          </p>
        </section>

        <section>
          <h2>5. Data Sharing</h2>
          <p>
            We do not sell or rent your data. However, we may share limited
            information under these conditions:
          </p>
          <ul>
            <li>
              With customers — to share your name or contact (for delivery
              coordination).
            </li>
            <li>
              With third-party service providers — such as payment processors,
              map providers, or identity verification services.
            </li>
            <li>
              With law enforcement or regulatory authorities — if required by
              applicable law.
            </li>
          </ul>
        </section>

        <section>
          <h2>6. Data Retention</h2>
          <p>
            We retain your personal information for as long as necessary to
            fulfill legal, tax, and operational requirements. Once your account
            is deactivated or terminated, we retain your data only for the period
            mandated by law or business necessity.
          </p>
        </section>

        <section>
          <h2>7. Data Protection & Security</h2>
          <p>
            RismicMart Pvt. Ltd. implements strict technical and organizational
            measures to protect your data against unauthorized access, misuse,
            or disclosure. All sensitive data and communications are transmitted
            using secure, encrypted channels.
          </p>
        </section>

        <section>
          <h2>8. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access or request a copy of your personal data.</li>
            <li>Request correction of inaccurate or outdated information.</li>
            <li>
              Withdraw consent or request deletion of data (subject to legal and
              contractual limits).
            </li>
          </ul>
          <p>
            To exercise any of these rights, please contact us through the
            details provided below.
          </p>
        </section>

        <section>
          <h2>9. Policy Updates</h2>
          <p>
            This Privacy Policy may be updated periodically to reflect new legal
            or operational requirements. All updates will be posted within the
            Delivery Partner App or communicated via email/SMS.
          </p>
        </section>

        <section>
          <h2>10. Contact Information</h2>
          <p>
            For any privacy-related questions, please contact us at:
            <br />
            <strong>Email:</strong> rismicmartpvtltd@gmail.com
            <br />
            <strong>Company:</strong> RismicMart Pvt. Ltd.
            <br />
            <strong>Address:</strong> CN 8/2, Sidco Global tower, Sector V, Kolkata.
          </p>
        </section>

        <div className="company-info">
          <p>
            © {new Date().getFullYear()} RismicMart Pvt. Ltd. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
